import Siema from 'siema';

// Add a function that generates pagination to prototype
Siema.prototype.addPagination = function() {
  const dotNav = document.createElement('ol');
  this.dots = [];
  for (let i = 0; i < this.innerElements.length; i++) {
    const li = document.createElement('li');
    const btn = document.createElement('button');
    btn.textContent = i;
    btn.addEventListener('click', () => this.goTo(i));
    this.dots.push(btn);
    li.appendChild(btn);
    dotNav.appendChild(li);
  }
  this.selector.appendChild(dotNav);
};

Array.from(document.querySelectorAll('.js-slideshow')).forEach(slideshow => {
  const siema = new Siema({
    selector: slideshow,
    speed: 350,
    loop: true,
    onChange: () => {
      // Update pagination state
      siema.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === siema.currentSlide);
      });
    },
  });

  // Trigger pagination creator
  siema.addPagination();

  // Auto-play
  const timer = setInterval(() => {
    siema.next();
  }, 5000);

  // Stop auto-playing if the user clicks anywhere within the slideshow
  siema.selector.addEventListener('click', () => {
    clearInterval(timer);
  });
});
